import { render } from "./lrbYTable4.vue?vue&type=template&id=73eea10d&scoped=true"
import script from "./lrbYTable4.vue?vue&type=script&lang=js"
export * from "./lrbYTable4.vue?vue&type=script&lang=js"

import "./lrbYTable4.vue?vue&type=style&index=0&id=73eea10d&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73eea10d"]])

export default __exports__